import { Modal, Select, Spin } from "antd"
import { useEffect, useState } from "react";
import axios from "axios";
import openAiChatCompletion from "controllers/openAiChatCompletion";

const backend = process.env.REACT_APP_BACKEND;

function CefrGptSelect ({record, dataChangeHandler, gptModel}) {
  const [cefrGpt, setCefrGpt] = useState(record.cefr_gpt)
  const [loading, setLoading] = useState(false)

  const cefrOption = [
    {value: "N/A", label: "N/A"},
    {value: "A0", label: "A0"},
    {value: "A1", label: "A1"},
    {value: "A2", label: "A2"},
    {value: "B1", label: "B1"},
    {value: "B2", label: "B2"},
    {value: "C1", label: "C1"},
    {value: "C2", label: "C2"},
  ]

  const changeValue = (value) => {
    const instance = JSON.parse(JSON.stringify(record))
    instance.cefr_gpt = value
    setCefrGpt(value)
    const values = {
      id: record.id,
      word: record.word,
      ContentSettingPartsOfSpeechMaster_code: record.ContentSettingPartsOfSpeechMaster_code,
      cefr_gpt: value === "N/A" ? null : value
    }
    axios
    .patch(`${backend}/contents/new_word/constituent_false/master`,{values})
    .then(res => {
      dataChangeHandler(instance, "cefr_gpt")
    })
    .catch(err=>{
      console.log(err)
      Modal.error({
       title: "저장에러",
       content: "서버에 에러가 발생하여 변경하지 못했습니다.",
       okText:"확인",
       afterClose: ()=>setCefrGpt(record.cefr_gpt)
      })
    })
  }

  const createByGpt = async () => {
    const { word, translate_text} = record
    const prompt = `Provide the estimated CEFR level of the word '${word}' with its Korean meaning '${translate_text}'. Provide only the CERF level without any explanation or other cues.`
    const translateTextByGpt = await openAiChatCompletion(prompt, gptModel)
    
    return translateTextByGpt
  }

  const createByGptHandler = async () => {
    setLoading(true)
    const value = await createByGpt()

    if(!value) {
      Modal.error({
        title: "GPT에러",
        content: "gpt에 오류가 발생했습니다. 답변 형식이 잘못되어 있을 수 있으니 console을 확인하세요.",
        okText:"확인",
        afterClose: ()=> setLoading(false)
      })
      return
    }

    const instance = JSON.parse(JSON.stringify(record))
    instance.cefr_gpt = value
    setCefrGpt(value)
    const values = {
      id: record.id,
      word: record.word,
      ContentSettingPartsOfSpeechMaster_code: record.ContentSettingPartsOfSpeechMaster_code,
      cefr_gpt: value === "N/A" ? null : value
    }
    axios
    .patch(`${backend}/contents/new_word/constituent_false/master`,{values})
    .then(res => {
      dataChangeHandler(instance, "cefr_gpt")
    })
    .catch(err=>{
      console.log(err)
      Modal.error({
       title: "저장에러",
       content: "서버에 에러가 발생하여 변경하지 못했습니다.",
       okText:"확인",
       afterClose: ()=>setCefrGpt(record.cefr_gpt)
      })
    })
    .finally(()=>{
      setLoading(false)
    })
  }

  useEffect(()=>{
    setCefrGpt(record.cefr_gpt)
  },[record])

  return (
    <div>
      <Spin spinning={loading}>
        <Select value={cefrGpt} options={cefrOption} style={{width:"80px", color: cefrGpt === "N/A" ? "red" : null}} onChange={changeValue}/>
        <a style={{margin:"0px 5px"}} aria-disabled={true} disabled={!record.translate_text} onClick={!record.translate_text ? null : createByGptHandler}>생성</a>
      </Spin>
  </div>
  )
}

export default CefrGptSelect